import { hotjar } from "react-hotjar";

const hotjarAccountId = 2870395;
const hotjarAccountSv = 6;

export default function initialisePlurallHotjar() {
  return hotjar.initialize(hotjarAccountId, hotjarAccountSv);
}
